import React from "react";
import classes from "./Button.module.scss";

// Extending the Props interface to include the disabled property
interface Props {
  type?: "button" | "submit";
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  outline?: boolean;
  disabled?: boolean;  // Adding disabled as an optional property
}

const Button: React.FC<Props> = (props) => {
  // Destructuring props for cleaner usage
  const { type = "button", onClick, outline, disabled, children } = props;

  // Constructing className string with all possible states
  const buttonClasses = `
    ${classes.btn}
    ${outline ? classes.outline : classes.button}
    ${disabled ? classes.disabled : ""}
  `.trim();

  return (
    <button
      className={buttonClasses}
      type={type}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;